module.exports = __webpack_public_path__ + "img/fun_m_6.96c05820.png";